'use client';

import { motion, useMotionValue } from "motion/react";
import { useState } from "react";

const randoRotations = () => Array.from({ length: 6 }, () => Math.floor(Math.random() * 360));
const rot1 = randoRotations();
const rot2 = randoRotations();

interface LoadingAnimationProps {
  fullWidth?: boolean;
}

const LoadingAnimation = ({ fullWidth = false }: LoadingAnimationProps) => {
    const [initialScale] = useState(() => Math.random() * (1.3 - .7) + .7);
    const randoScale = useMotionValue(initialScale);
    const randoRotate = useMotionValue(rot1);
    const randoRotate2 = useMotionValue(rot2);

    const radialVariant = {
        mainInitial: {
            background: `radial-gradient(at 50% 50%, #53B8EB 0%, rgba(130,170,201, .5) 30%, rgba(217, 217, 217, 0.1) 35%, transparent 41%), radial-gradient(at 55% 50%, #C8DF52 0%, transparent 25%)`,
        },
        main: {
            scale: [1, 1.1, randoScale.get(), 1, 0.7],
            opacity: [1, .5, 1],
            rotate: randoRotate.get(),
            x: [0, 50, -50],
            y: [0, 0, -25, 25]
        },
        secondaryInitial: {
            background: `radial-gradient(at 51% 49%, #53B8EB 0%, transparent 40%), radial-gradient(at 60% 50%, #C8DF52 0%, transparent 20%)`,
        },
        secondary: {
            scale: [1, 1.1, 0.7, 1.1, randoScale.get()],
            opacity: [1, .5, .9],
            rotate: randoRotate2.get(),
            x: [0, 50, -50],
            y: [0, 0, -25, 25]
        }
    }

    return (
        <div className={`absolute ${fullWidth ? 'w-[150%] left-[-25%]' : 'w-[728px] left-1/2 -translate-x-1/2'} ${fullWidth ? 'h-full' : 'h-[780px]'} inset-0 top-1/2 -translate-y-1/2 overflow-hidden`}>
            <motion.div
                className="overflow-hidden w-full h-full absolute"
                style={{
                    zIndex: -1,
                }}
                initial="mainInitial"
                variants={radialVariant}
                animate="main"
                transition={{
                    delay: 1,
                    duration: 8,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "easeInOut",
                }}
            >
            </motion.div>
            <motion.div
                className="overflow-hidden w-full h-full absolute"
                style={{
                    zIndex: -2,
                }}
                initial="secondaryInitial"
                variants={radialVariant}
                animate="secondary"
                transition={{
                    delay: .3,
                    duration: 7,
                    repeat: Infinity,
                    repeatType: "reverse",
                    ease: "linear",
                    damping: 8,
                }}
            >
            </motion.div>
        </div>
    );
};

export default LoadingAnimation; 